import { render, staticRenderFns } from "./Phases.vue?vue&type=template&id=01b575e4&scoped=true&"
import script from "./Phases.vue?vue&type=script&lang=js&"
export * from "./Phases.vue?vue&type=script&lang=js&"
import style0 from "./Phases.vue?vue&type=style&index=0&id=01b575e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b575e4",
  null
  
)

export default component.exports